// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum IInvoiceType {
    REIMBURSEMENT = 'REIMBURSEMENT',
    REPAYMENT = 'REPAYMENT',
    ADHOC_CONTRIBUTION = 'ADHOC_CONTRIBUTION',
    CARD_SETTLEMENT = 'CARD_SETTLEMENT',
    REPLENISHMENT = 'REPLENISHMENT',
    CONTRIBUTIONS = 'CONTRIBUTIONS',
    BILL_PAY = 'BILL_PAY',
    BUY_INVESTMENT = 'BUY_INVESTMENT',
    SELL_INVESTMENT = 'SELL_INVESTMENT',
    TRANSFER_OF_ASSETS = 'TRANSFER_OF_ASSETS',
    INTEREST_ACCRUAL = 'INTEREST_ACCRUAL',
    ORGANIZATION_LEVEL_PREFUND_REPLENISHMENT = 'ORGANIZATION_LEVEL_PREFUND_REPLENISHMENT',
    DIGITAL_SETTLEMENT = 'DIGITAL_SETTLEMENT',
    PLAN_LEVEL_REPLENISHMENT = 'PLAN_LEVEL_REPLENISHMENT',
    PLAN_LEVEL_CONTRIBUTIONS = 'PLAN_LEVEL_CONTRIBUTIONS',
    PLAN_LEVEL_PREFUND_REPLENISHMENT = 'PLAN_LEVEL_PREFUND_REPLENISHMENT',
    ORGANIZATION_LEVEL_CONTRIBUTIONS = 'ORGANIZATION_LEVEL_CONTRIBUTIONS',
    ORPHAN_EE_FEES = 'ORPHAN_EE_FEES',
    ADMIN_FEES = 'ADMIN_FEES',
    CASHLESS_SELL_INVESTMENT = 'CASHLESS_SELL_INVESTMENT',
    CASHLESS_BUY_INVESTMENT = 'CASHLESS_BUY_INVESTMENT',
    MANAGED_INVESTMENT = 'MANAGED_INVESTMENT',
    SELF_DIRECTED_INVESTMENT = 'SELF_DIRECTED_INVESTMENT',
    PAYMENT_EE_FEES = 'PAYMENT_EE_FEES',
    INVESTMENT_EE_FEES = 'INVESTMENT_EE_FEES',
    ACCOUNT_MAINTENANCE_EE_FEES = 'ACCOUNT_MAINTENANCE_EE_FEES',
    PAPER_STATEMENT_EE_FEES = 'PAPER_STATEMENT_EE_FEES',
    ORGANIZATION_LEVEL_PREFUND_REPLENISHMENT_RETURN = 'ORGANIZATION_LEVEL_PREFUND_REPLENISHMENT_RETURN',
    PLAN_LEVEL_PREFUND_REPLENISHMENT_RETURN = 'PLAN_LEVEL_PREFUND_REPLENISHMENT_RETURN',
    PLAN_PREFUND_SPENDDOWN = 'PLAN_PREFUND_SPENDDOWN',
    ORGANIZATION_NOTIONAL_CONTRIBUTION = 'ORGANIZATION_NOTIONAL_CONTRIBUTION',
    PLAN_NOTIONAL_CONTRIBUTION = 'PLAN_NOTIONAL_CONTRIBUTION',
    EOY_PLAN_RECONCILIATION = 'EOY_PLAN_RECONCILIATION',
    BALANCE_ADJUSTMENT = 'BALANCE_ADJUSTMENT'
}


export function instanceOfIInvoiceType(value: any): boolean {
    for (const key in IInvoiceType) {
        if (Object.prototype.hasOwnProperty.call(IInvoiceType, key)) {
            if (IInvoiceType[key as keyof typeof IInvoiceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function IInvoiceTypeFromJSON(json: any): IInvoiceType {
    return IInvoiceTypeFromJSONTyped(json, false);
}

export function IInvoiceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvoiceType {
    return json as IInvoiceType;
}

export function IInvoiceTypeToJSON(value?: IInvoiceType | null): any {
    return value as any;
}

export function IInvoiceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): IInvoiceType {
    return value as IInvoiceType;
}

